import { useEffect, useRef, type JSX } from "react";
import { useStore } from "../store/globalState";
import { CloseLight } from "../assets/navIcons";

export interface PopupProps {
  children: JSX.Element;
  visible?: boolean;
  onClose: () => void;
}

export const Popup: React.FC<PopupProps> = ({ visible, onClose, children }) => {
  const ref = useRef<HTMLDivElement>(null);
  const { footerColor } = useStore().theme.whiteView;

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) onClose();
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!visible) return null;

  return (
    <>
      <span className="popup-blur" />
      <main ref={ref} role="alert" className="popup-component">
        <CloseLight
          className="close-popup-icon"
          onClick={onClose}
          colors={[footerColor, footerColor]}
        />
        {children}
      </main>
    </>
  );
};
